const article = {
  slug: 'payments',
  title: 'Payments - take, record, refund',
  section: 'Money',
  body: `
# Payments

## Take a payment (card, present or not)

**Payments -> Take payment** (or the card icon on a customer row) starts
a card payment through the payment processor. The tenant can also pay
from their portal. Balances move when the processor confirms - the
ledger is webhook-driven, so a lost internet tab can't double-charge.

## Record a payment (cash / check / external)

**Payments -> Record payment** books money you already collected: cash,
check, money order, or a charge made directly in the processor
dashboard. Pick the rental so the balance and open invoices update.
Put check numbers / references in notes.

## Refunds

On the payment row, use the **refund** action:

- **Card refunds** go back through the processor; the ledger updates
  when it confirms. Partial refunds are supported up to the remaining
  un-refunded amount.
- **External refunds** (cash given back, check) just book the ledger
  entry - money moved outside the system.

## ACH bank payments

ACH is a per-facility switch (**Settings -> Facility -> ACH bank
payments**, off by default). Bank transfers settle in ~4 business days:
the balance moves immediately, invoices settle on confirmation, and a
returned transfer automatically restores the balance, charges your NSF
fee, and notifies the tenant.
`,
};

export default article;
